export default __webpack_public_path__ + "static/media/gallery_03.236d2a00.jpg";